import { Icon } from "@/components/common/icon/Icon";
import { formatNumber } from "@/modules/auth/utils/format";
import { useTranslation } from "react-i18next";

type LevelProps = {
  level: number;
  rewardPercent: number;
  personalActiveVolumeUsd: number;
  referralsHistoricalVolumeUsd: number;
  usdt: number;
  referralsNumber: number;
  allReferralsNumber: number;
  locked: boolean;
};

const Level = ({
  level,
  rewardPercent,
  personalActiveVolumeUsd,
  referralsHistoricalVolumeUsd,
  usdt,
  referralsNumber,
  allReferralsNumber,
  locked,
}: LevelProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full flex items-center justify-between gap-4 px-4">
      <div className="flex flex-col gap-0.5 py-3">
        <div className="flex items-center gap-1">
          <p
            className={`text-[1.0625rem] leading-[1.375rem] ${
              locked ? "text-subtitle-text" : "text-text"
            }`}
          >
            #{level}
          </p>
          {locked && <Icon type="lock" className="fill-link w-5 h-5" />}
        </div>

        <p className="text-[0.9375rem] leading-[1.25rem] text-accent-text">
          {rewardPercent}% {t("network-page.rewards")}
        </p>

        {locked && (
          <p className="text-[0.8125rem] leading-[1rem] text-subtitle-text">
            {level >= 4
              ? t("network-page.unlock_prev", {
                  personal: formatNumber(personalActiveVolumeUsd),
                  referral: formatNumber(referralsHistoricalVolumeUsd),
                  line: level - 1,
                })
              : t("network-page.unlock", {
                  personal: formatNumber(personalActiveVolumeUsd),
                  referral: formatNumber(referralsHistoricalVolumeUsd),
                })}
          </p>
        )}
      </div>

      <div className="shrink-0 flex flex-col items-end gap-0.5">
        <p
          className={`text-[1.0625rem] leading-[1.375rem] ${
            locked ? "text-subtitle-text" : "text-text"
          }`}
        >
          ${formatNumber(usdt)}
        </p>
        <p className="text-[0.9375rem] leading-[1.25rem] text-hint">
          {t("network-page.refs", {
            count: referralsNumber,
          })}
        </p>
        <p className="text-[0.9375rem] leading-[1.25rem] text-hint">
          {t("network-page.all_refs", {
            count: allReferralsNumber,
          })}
        </p>
      </div>
    </div>
  );
};

export default Level;
